<template>
	<div class="db2-bar" :class="['is-' + variant, isHorizontal ? 'is-horizontal' : 'is-vertical']">
		<template v-if="variant === 'relative'">
			<template v-if="isHorizontal">
				<div class="db2-rank-row" v-for="(row, i) in rows" :key="i">
					<div class="db2-rank-meta">
						<span>{{ row.name }}</span>
						<strong>{{ row.value }}% · {{ row.hours }} h</strong>
					</div>
					<div class="db2-rank-track">
						<div class="db2-rank-fill" :class="{ warn: row.warn }" :style="{ width: row.value + '%' }"></div>
					</div>
				</div>
			</template>
			<div class="db2-rank-cols" v-else>
				<div class="db2-rank-col" v-for="(row, i) in rows" :key="i">
					<div class="db2-rank-track">
						<div class="db2-rank-fill" :class="{ warn: row.warn }" :style="{ height: row.value + '%' }"></div>
					</div>
					<span class="db2-rank-name">{{ row.name }}</span>
					<strong>{{ row.value }}%</strong>
				</div>
			</div>
		</template>
		<HaqEChart v-else :option="option" height="100%" />
	</div>
</template>

<script>
import HaqEChart from '../HaqEChart.vue';
import { mockRankRows, mockAxisLabels } from '../mockPointData';
import { chartTheme, baseChartOption, CHART_FONT } from '../chartTheme';

/**
 * Map saved bar variants onto Absolute / Relative.
 * @param {string} raw
 * @returns {string}
 */
function barVariant(raw) {
	if (raw === 'ranking' || raw === 'relative' || raw === 'tableBars') return 'relative';
	return 'absolute';
}

/**
 * Absolute (ECharts) or relative (percent tracks) bar card.
 */
export default {
	name: 'BarCard',
	components: { HaqEChart },
	props: {
		card: { type: Object, required: true },
		timePeriod: { type: String, default: 'week' }
	},
	computed: {
		/**
		 * Visual variant.
		 * @returns {string}
		 */
		variant() {
			return barVariant(this.card.config && this.card.config.variant);
		},
		/**
		 * Horizontal tracks vs vertical columns.
		 * @returns {boolean}
		 */
		isHorizontal() {
			return (this.card.config && this.card.config.orientation) !== 'vertical';
		},
		/**
		 * Mock rows.
		 * @returns {Array}
		 */
		rows() {
			return mockRankRows(this.card.uniqueId, 6);
		},
		/**
		 * ECharts option for absolute bars.
		 * @returns {object}
		 */
		option() {
			const t = chartTheme();
			const horizontal = this.isHorizontal;
			const labels = mockAxisLabels(this.timePeriod, this.rows.length);
			const data = this.rows.map(r => r.value);
			const cat = horizontal ? this.rows.map(r => r.name) : labels;
			return {
				...baseChartOption(t),
				grid: { left: horizontal ? 84 : 44, right: 12, top: 12, bottom: horizontal ? 16 : 36 },
				xAxis: horizontal
					? { type: 'value', splitLine: { lineStyle: { color: t.line } }, axisLabel: { color: t.muted, fontSize: CHART_FONT } }
					: { type: 'category', data: cat, axisLabel: { color: t.muted, fontSize: CHART_FONT }, axisLine: { lineStyle: { color: t.line } } },
				yAxis: horizontal
					? { type: 'category', data: cat, axisLabel: { color: t.muted, fontSize: CHART_FONT } }
					: { type: 'value', splitLine: { lineStyle: { color: t.line } }, axisLabel: { color: t.muted, fontSize: CHART_FONT } },
				series: [{ type: 'bar', data, itemStyle: { color: t.accent, borderRadius: 4 }, barMaxWidth: 18 }]
			};
		}
	}
};
</script>
